import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const commonRoutes = [
    {
        path: '/login',
        name: 'login',
        meta: {title: '登录'},
        component: () => import('../components/Login.vue'),
    },
    {
        path: '/404',
        name: '404',
        meta: {title: '404'},
        component: () => import('../components/404.vue'),
    },
    {path: '/', redirect: '/home'},
]

// 本地所有的页面 需要配合后台返回的数据生成页面
export const asyncRoutes = {
    home: {
        path: 'home',
        name: 'home',
        meta: {title: '主页'},
        component: () => import('../views/Home.vue'),
    },
    msg: {
        path: 'msg',
        name: 'msg',
        meta: {title: '通知消息'},
        component: () => import('../views/Msg.vue'),
    },
    userinfo: {
        path: 'userinfo',
        name: 'userinfo',
        meta: {title: '用户信息'},
        component: () => import('../views/Base/PersonCenter.vue'),
    },
    userManage: {
        path: 'userManage',
        name: 'userManage',
        meta: {title: '人员管理'},
        component: () => import('../views/Base/UserManage'),
    },
    userGroup: {
        path: 'userGroup',
        name: 'userGroup',
        meta: {title: '工作组管理'},
        component: () => import('../views/Base/UserGroup'),
    },
    merchantManage: {
        path: 'merchantManage',
        name: 'merchantManage',
        meta: {title: '商家管理'},
        component: () => import('../views/Base/MerchantManage'),
    },
    storeManage: {
        path: 'storeManage',
        name: 'storeManage',
        meta: {title: '门店管理'},
        component: () => import('../views/Base/StoreManage'),
    },
    roleManage: {
        path: 'roleManage',
        name: 'roleManage',
        meta: {title: '角色管理'},
        component: () => import('../views/Base/RoleManage'),
    },
    memberManage: {
        path: 'memberManage',
        name: 'memberManage',
        meta: {title: '会员管理'},
        component: () => import('../views/Base/MemberManage'),
    },
    materialsCatalog: {
        path: 'materialsCatalog',
        name: 'materialsCatalog',
        meta: {title: '材料目录'},
        component: () => import('../views/BaseData/MaterialsCatalog'),
    },
    materialsManage: {
        path: 'materialsManage',
        name: 'materialsManage',
        meta: {title: '材料管理'},
        component: () => import('../views/BaseData/MaterialsInfo'),
    },
    itemClassify: {
        path: 'itemClassify',
        name: 'itemClassify',
        meta: {title: '项目分类'},
        component: () => import('../views/BaseData/ItemClassify'),
    },
    itemManage: {
        path: 'itemManage',
        name: 'itemManage',
        meta: {title: '项目管理'},
        component: () => import('../views/BaseData/ItemInfo'),
    },
    receiveCar: {
        path: 'receiveCar',
        name: 'receiveCar',
        meta: {title: '接车'},
        component: () => import('../views/Business/ReceiveCar'),
    },
    repairInfo: {
        path: 'repairInfo',
        name: 'repairInfo',
        meta: {title: '维修信息'},
        hidden: true,
        component: () => import('../views/Business/RepairInfo'),
    },
    underRepair: {
        path: 'underRepair',
        name: 'underRepair',
        meta: {title: '在厂车辆'},
        component: () => import('../views/Business/UnderRepairCar'),
    },
    orderCashier: {
        path: 'orderCashier',
        name: 'orderCashier',
        meta: {title: '收银'},
        component: () => import('../views/Business/OrderCashier'),
    },
    facialOrderCashier: {
        path: 'facialOrderCashier',
        name: 'facialOrderCashier',
        meta: {title: '收银'},
        component: () => import('../views/Facial/FacialOrderCashier'),
    },
    storeSetting: {
        path: 'storeSetting',
        name: 'storeSetting',
        meta: {title: '门店设置'},
        component: () => import('../views/BaseData/StoreSetting'),
    },
    supplier: {
        path: 'supplier',
        name: 'supplier',
        meta: {title: '供应商管理'},
        component: () => import('../views/BaseData/SupplierManage'),
    },
}

const createRouter = () => new Router({
    routes: commonRoutes,
})

const router = createRouter()

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher
}

export default router
